import {Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {ConfigService} from "../../../config.service";
import {CookieService} from 'ngx-cookie-service';
import {Router, RouterModule} from '@angular/router';
import {UserProperties, UserPropertiesService} from "../../services/user-properties.service";
import {
    TrialDaysLeftDynamicDialogComponent
} from "../../../shared/components/trial-days-left-dynamic-dialog/trial-days-left-dynamic-dialog.component";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {SubscriptionsService} from "../../services/subscriptions.service";
import {PlanType, SubscriptionDetail, Subscriptions} from "../../model/subscriptions.models";
import {CurrencySymbolPipe} from "../../../shared/pipes/currency-symbol.pipe";
import {DividerModule} from "primeng/divider";
import {log} from "@angular-devkit/build-angular/src/builders/ssr-dev-server";
import {OnboardingComponent} from "../../onboarding/onboarding.component";
import {CurrencyFormatPipe} from "../../../shared/pipes/CurrencyFormatPipe";
import normalizeExternalHTML from "quill/modules/normalizeExternalHTML";
import {Button} from "primeng/button";
import {APP_CONFIG} from "../../../app-config";

@Component({
    selector: 'app-signature-navigation',
    standalone: true,
    imports: [
        CommonModule,
        TranslatePipe,
        RouterModule,
        CurrencySymbolPipe,
        DividerModule,
        CurrencyFormatPipe,
        Button
    ],
    providers: [CookieService],
    templateUrl: './signature-navigation.component.html',
    styleUrl: './signature-navigation.component.scss'
})
export class SignatureNavigationComponent implements OnInit, OnChanges {

    appConfig = inject(APP_CONFIG);
    @Output() activeRightContentEvent = new EventEmitter<string>();
    @Output() signEvent = new EventEmitter<string>();
    @Input() loggedInUserData: any;
    @Input() userSubscription!: Subscriptions;
    selectedContent: string = 'home';
    currentUser = "";
    profilePictureUserProperty!: UserProperties;
    firstLettersOfUserName!: string;
    trialDaysLeftDialogRef!: DynamicDialogRef;
    onBoardingDynamicDialogRef!: DynamicDialogRef;
    trialDaysLeft!: number;

    signsAvailable: number = 5;
    signsUsed: number = 3;

    constructor(private configService: ConfigService,
                private cookieService: CookieService,
                private router: Router,
                private userPropertiesService: UserPropertiesService,
                private dialogService: DialogService,
                private subscriptionsService: SubscriptionsService) {
    }

    ngOnInit() {

        this.subscriptionsService.refreshCreditValue.subscribe(value => {
            this.subscriptionsService.getCurrentUsersSubscriptions().subscribe(subscription => {
                this.userSubscription = subscription;
            });
        });

        this.configService.currentUser$.subscribe((user) => {
            this.currentUser = user.firstname + ' ' + user.lastname;
            this.firstLettersOfUserName = user.firstname[0] + user.lastname[0];
        });

        if (!this.currentUser && this.configService.currentUser) {
            const user = this.configService.currentUser;
            this.currentUser = user?.firstname + ' ' + user?.lastname;
        }

        this.userPropertiesService.getByKey('sipo.profile.picture').subscribe(res => {
            this.profilePictureUserProperty = res;
        })

        this.userPropertiesService.getByKey('sipo.settings.isonboarding').subscribe(res => {
            if (res.userPropertyValue === 'false') {
                this.openOnboardingDynamicDialog(false);
            }
        })


    }


    // ToDo: check test period
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['userSubscription'] && changes['userSubscription'].currentValue) {
            const daysLeft = this.calculateDaysLeft(this.userSubscription.testStartDate, this.userSubscription.testDuration);


            if (this.userSubscription?.plan?.toLowerCase() === 'business') {
                this.subscriptionsService.getSubscriptionInfo().then(value => {
                    console.log(value);

                    const singsQesFes = Number(value.fesCount + value.qesCount);

                    if (singsQesFes > 0) {
                        this.signsUsed= 5;
                    } else {
                        this.signsUsed = Number(value.fesCount + value.qesCount);
                    }

                });
            }

            setTimeout(() => {
                // Show upgrade screen only if starter plan has expired.
                const excludedPlans: PlanType[] = [PlanType.BASIC, PlanType.BUSINESS];

                if (daysLeft && daysLeft <= 0 && !excludedPlans.includes(this.userSubscription.plan as PlanType)) {
                    this.openPaymentComponent('subscriptionPayment', true);
                }
            }, 2500);
        }
    }

    openPaymentComponent(pt: 'subscriptionPayment' | 'creditPayment', isAutoRouted: boolean) {
        this.router.navigate(['/payment'], {
            queryParams: {purchaseType: pt, isAutoRouted: isAutoRouted}
        });
    }

    openOnboardingDynamicDialog(isOpenedManually: boolean) {
        this.onBoardingDynamicDialogRef = this.dialogService.open(OnboardingComponent, {
            header: 'Onboarding',
            width: '50%',
            height: '95%',
            contentStyle: {overflow: 'hidden'},
            data: {
                isOpenedManually: isOpenedManually
            }
        })
    }

    updateSubs(plan: 'Starter' | 'Basic' | 'Business') {
        this.userSubscription.plan = plan;
        this.userSubscription.credit = 0;
        this.subscriptionsService.updateUserSubscriptions(this.userSubscription).subscribe(res => {
            console.log(res);
            window.location.reload();
        })
    }

    calculateDaysLeft(dateStart: string | null, testDuration: number): number {
        if (!dateStart) {
            return 0;
        }

        const startDate = new Date(dateStart);
        if (isNaN(startDate.getTime())) {
            return 0; // ungültiges Datum
        }

        // Enddatum = Start + Dauer in Tagen
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + testDuration);

        const today = new Date();

        // Differenz in Tagen berechnen
        const diffMs = endDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    }


    public changeRightContent(componentName: string): void {
        this.selectedContent = componentName;
        this.activeRightContentEvent.emit(componentName);
    }

    logout() {
        this.cookieService.deleteAll();
        this.router.navigateByUrl('/').then(() => {
            window.location.reload();
        });
    }

    sign($event: MouseEvent) {
        this.signEvent.emit('sign');
    }

    test() {
        console.log('test');
    }
}
